import { tw } from "@careinfo/tailwind";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const FileUpload = (props: any) => {
  const { label, register, watch, errors, setValue, disabled = false } = props;
  const [url, setUrl] = useState<string | null>(null);
  const [isImage, setIsImage] = useState<boolean>(false);

  const file = watch(register?.name);

  useEffect(() => {
    if (!file) {
      setUrl(null);
      return;
    }

    if (typeof file === "string") {
      setUrl(file);
      setIsImage(file.match(/\.(jpeg|jpg|png|gif|webp)$/i) !== null);
      return;
    }

    if (file?.length > 0) {
      const selectedFile = file[0];
      if (selectedFile.type.startsWith("video/")) {
        toast.error("Video files not allowed!");
        setUrl(null);
        setValue(register?.name, null);
        setIsImage(false);
        return;
      }
      const objectUrl = URL.createObjectURL(selectedFile);
      setIsImage(selectedFile.type.startsWith("image/"));
      setUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [file]);

  return (
    <div className={tw`mt-3`}>
      <span className="">{label}</span>
      <div
        className={tw`input_field border-2 border-gray-200 rounded-lg flex flex-col w-full mx-auto text-center mt-2`}
      >
        <label>
          <input
            disabled={disabled}
            className={tw`text-sm cursor-pointer w-full hidden`}
            {...register}
            type="file"
          />

          {typeof file === "string" ? (
            isImage ? (
              <img
                src={file}
                alt="Default Preview"
                className={tw`w-full h-28 object-contain my-2`}
              />
            ) : (
              <div
                className={tw`h-28 my-2 text-lg flex items-center justify-center text-gray-500`}
              >
                <a href={file} target="_blank" rel="noopener noreferrer">
                  Download File
                </a>
              </div>
            )
          ) : file && file.length > 0 ? (
            isImage && url ? (
              <img
                src={url}
                alt="Preview"
                className={tw`w-full h-28 object-contain my-2`}
              />
            ) : (
              <div
                className={tw`h-28 my-2 text-lg flex items-center justify-center text-gray-500`}
              >
                File selected: {file[0]?.name}
              </div>
            )
          ) : (
            <div className={tw`h-28 mt-4`}>
              <svg
                className={tw`text-primary w-full mx-auto mb-4 cursor-pointer`}
                xmlns="http://www.w3.org/2000/svg"
                height="80px"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                />
              </svg>
            </div>
          )}
        </label>
        <p className={tw`text-sm text-red-600`}>
          {errors[register?.name]?.message}
        </p>
      </div>
    </div>
  );
};

export default FileUpload;
